import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _EmployeeBonus, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { EmployeeBonusTypeConstatsEditor } from "./Editors/EmployeeBonusTypeConstats.edtior";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { EmploymentBonusValue } from "./EmploymentBonusValue/EmploymentBonusValue";
import { AppointMentByEmploymentBonu } from "./EmploymentAppointment/AppointMentByEmploymentBonu";
import { TaxHoldeditor } from "../EmployeePayments/EmployeePayments.editor";
import { WelfareEntityTypeEditor } from "./Editors/WelfareEntityType.Editor";
import { MultiMonthEditor } from "./Editors/MultiMonthEditor";
import { MultiEmploymentTypeEditor } from "./Editors/MultiEmploymentType.editor";
import { AccountEditor } from "../../../editor/AccountEditor";
import { InputDate } from "../../../theme/Input/InputDate";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { PayrollFactorVdosSelect } from "../PayrollFactorVdos/PayrollFactorVdosSelect";
import { EmployeeBenefitEditor } from "../EmployeeBenefit/EmployeeBenefitEditor";

export const EmployeeBonus = () => {


    const { instance, lista, setLista, bean, setBean, handleChange, validate, isMissing, isRequired, addRequiredFields } = useDataBean(_EmployeeBonus);

    const [response, setResponse] = useState<any>({});

    const defaultBean = {
        ActiveBonus: true,
        UserValue: false,
        WageFactor: true,
        FortnightInclude: false,
        DoProvision: false,
        BonusFormula: "com.colombia.ley100.Default",
        ApplyBudget: false,
        ApportionmentTime: false,
        DoLiquidate: false,
        DoTaxHold: false,
        DoDiscounts: false,
        DoVacProvision: false,
        PaymentToWelfare: false,
        UseWelfareBudget: false,
        ProvisionCalculationMonths: 12,
        ProvisionCalculationPercent: 100,
        BonusValue: 0,
        BringToPresentValue: false,
        ApplyToIBCWithoutTimeRate: false,
    };

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEBV, setModalEBV] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalAppointment, setModalAppointment] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalAllAppointment, setModalAllAppointment] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalAddUser, setModalAddUser] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        const requiredFields = [
            "Code",
            "Name",
            "Type",
            "BonusValue",
            "MinSalary",
            "MaxSalary",
            "MonthsJson",
            "EmploymentTypeJson",
            "BonusFormula",
            "ProvisionCalculationMonths",
            "ProvisionCalculationPercent",
            "IDEmployeeBenefit",
        ];

        if (bean.DoProvision === true) {
            requiredFields.push("ProvisionAccountantID");
        }

        if (bean.PaymentToWelfare === true) {
            requiredFields.push("WelfareType");
        }

        if (bean.BringToPresentValue === true) {
            requiredFields.push("DiscountRate", "TurnoverRate");
        }

        addRequiredFields(requiredFields);
    }, [bean.DoProvision, bean.PaymentToWelfare, bean.BringToPresentValue])


    const getLista = () => {
        instance.getEmployeeBonusCatalog(null).then(
            (resp) => {
                resp.forEach(element => {
                    const bonus = element.DataBeanProperties;

                    bonus.BenefitData = bonus.IDEmployeeBenefit ? `${bonus.EmployeeBenefitCode} - ${bonus.EmployeeBenefitName}` : "N/P"

                });
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean(defaultBean);
        setModal({ ...modal, "name": "Agregar Prima Acional/Bonificaciones", "view": true });
    }

    const deleteItem = () => {
        instance.deleteVoid(bean.IDEmploymentBonus).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
                _single.delete(bean.IDEmploymentBonus, bean)
            }
        ).catch(err => toast.error(err))

    }

    const editaItem = () => {
        const missing = validate();
        console.log("Propiedades faltantes EmployeeBonus", missing);

        if (missing.length > 0) {
            toast.error("Faltan campos obligatorios por diligenciar");
            return;
        }

        const beanToSave = {
            ...defaultBean,
            ...bean,
            MonthsJson: Array.isArray(bean.MonthsJson) ? JSON.stringify(bean.MonthsJson) : bean.MonthsJson,
            EmploymentTypeJson: Array.isArray(bean.EmploymentTypeJson) ? JSON.stringify(bean.EmploymentTypeJson) : bean.EmploymentTypeJson,
        };

        instance.bean = beanToSave;
        instance.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                if (beanToSave.IDEmploymentBonus) {
                    _single.update(beanToSave)
                } else {
                    _single.create(beanToSave)
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const addEmployeeToBonus = () => {
        instance.createEmployeeBonus(bean.IDEmploymentBonus, response.IDAccount, response.BonusValue, _single.getAccountID(), response.IsTemporary, response.From, response.Upto).then(
            (resp) => {
                setModalAddUser({ ...modalAddUser, "view": false });
                setResponse({});

            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const activateBonus = () => {
        instance.addEmployeeBonusToAllAppointments(bean.IDEmploymentBonus, _single.getAccountID()).then(
            (resp) => {
                //console.log(resp);
                setModalAllAppointment({ ...modalAllAppointment, "view": false });
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDEmploymentBonus', visible: true },
        { title: 'Activo', property: 'ActiveBonus', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Valor', property: 'BonusValue', visible: true },
        //    { title: 'Valor Tiempo Laborado para IBC', property: 'ApportionmentTimeForPila', visible: true },
        { title: 'Factor de Configuración de Nómina', property: 'PayrollFactorName', visible: true },
        { title: 'Vr Usuario', property: 'UserValue', visible: true },
        { title: 'Vr Mínimo', property: 'MinSalary', mask: MASK_MONEY, visible: true },
        { title: 'Vr Máximo', property: 'MaxSalary', mask: MASK_MONEY, visible: true },
        { title: 'Meses', property: 'MonthsJsonName', visible: true },
        { title: 'Grupos Laborales', property: 'EmploymentTypeJsonName', visible: true },
        { title: 'Factor Salarial', property: 'WageFactor', visible: true },
        { title: 'Incluir en Nomina', property: 'FortnightInclude', visible: true },
        { title: 'Aplicar Retractivo', property: 'ApplyRetroactive', visible: true },
        // { title: 'Cuenta por Pagar', property: 'AccountantIDName', visible: true },
        // { title: 'Cuenta de Gasto', property: 'ExpensiveAccountantIDName', visible: true },
        // { title: 'Cuenta de Costo', property: 'CostAccountantIDName', visible: true },
        { title: 'Provisionar', property: 'DoProvision', visible: true },
        // { title: 'Cuenta de Provision', property: 'ProvisionAccountantIDName', visible: true },
        { title: 'Clase Liquidador Prima', property: 'BonusFormula', visible: true },
        // { title: 'Aplica Presupuesto', property: 'ApplyBudget', visible: true },
        // { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Factor de Retencion', property: 'TaxHoldName', visible: true },
        { title: 'Validar Tiempo Laborado', property: 'ApportionmentTime', visible: true },
        { title: 'Incluir en Liquidacion Final', property: 'DoLiquidate', visible: true },
        { title: 'Retefuente ', property: 'DoTaxHold', visible: true },
        { title: 'Descuentos ', property: 'DoDiscounts', visible: true },
        { title: 'Provision Seguridad Social', property: 'DoVacProvision', visible: true },
        { title: 'Nomina Electronica', property: 'IDElectronicPayroll', visible: true },
        { title: 'Pagar a Fondo', property: 'PaymentToWelfare', visible: true },
        { title: 'Tipo Fondo', property: 'WelfareType', visible: true },
        { title: 'Usar Rubro Fondo', property: 'UseWelfareBudget', visible: true },
        { title: 'Aplicar a IBC sin Prorrateo de Tiempo', property: 'ApplyToIBCWithoutTimeRate', visible: true },
        { title: 'Meses de Provisión', property: 'ProvisionCalculationMonths', visible: true },
        { title: '% Provisión', property: 'ProvisionCalculationPercent', visible: true },
        { title: 'Trae Beneficio a Valor Presente', property: 'BringToPresentValue', visible: true },
        { title: 'Tasa de Descuento', property: 'DiscountRate', visible: true },
        { title: 'Tasa de Rotación', property: 'TurnoverRate', visible: true },
        { title: 'Beneficio de Empleado', property: 'BenefitData', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Prima Adicional/Bonificaciones', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": "Editar Primas Adicionales y Bonificaciones", "view": true }) } },
            { titulo: 'Eliminar Prima Adicional/Bonificaciones', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "name": 'Eliminar Valor del Beneficio', "view": true }) } },
            { titulo: 'Agregar Empleado a Beneficio', icono: 'ri-user-add-line', visible: _single.canCreate(), evento: () => { setModalAddUser({ ...modalAddUser, "name": 'Agregar Empleado a Beneficio', "view": true }) } },
            { titulo: 'Definir Valor/Empleado', icono: 'ri-currency-line', visible: true, evento: () => { setModalEBV({ ...modalEBV, "name": "Definir Valor/Empleado", "view": true }) } },
            { titulo: 'Activar beneficio en todos los niveles salariales', icono: 'ri-folder-shared-line', visible: true, evento: () => { setModalAllAppointment({ ...modalAllAppointment, "name": "Activar beneficio en todos los niveles salariales", "view": true }) } },
            { titulo: 'Activar/Desactivar Beneficio por Nivel Salarial', icono: 'ri-file-settings-line', visible: true, evento: () => { setModalAppointment({ ...modalAppointment, "name": "Activar/Desactivar Beneficio por Nivel Salarial", "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <>
            <BasicPage titulo="Primas Adicionales y Bonificaciones">
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
                    </div>

                </div>
            </BasicPage>

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Activo" estado={bean.ActiveBonus} eventChange={(e) => { setBean({ ...bean, "ActiveBonus": e }) }} />
                        </div>
                        <div className="col-6">
                            <label className={`${isMissing('Code') ? 'has-error' : ''}`}>Código {isRequired('Code') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" name="Code" value={bean.Code ?? ""} onChange={handleChange} />
                        </div>
                        <div className="col-6">
                            <label className={`${isMissing('Name') ? 'has-error' : ''}`}>Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name ?? ""} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Factor de Configuración de Nómina</label>
                            <PayrollFactorVdosSelect render={bean.PayrollFactorName} idSelector={bean.IDPayrollFactor} onChange={(e) => { setBean({ ...bean, "IDPayrollFactor": e.IDPayrollFactor, "PayrollFactorName": e.Name }) }} label=" " returnType="Object" />
                        </div>
                        <div className={`col-6 ${isMissing('Type') ? 'has-error' : ''}`}>
                            <label className={`${isMissing('Type') ? 'has-error' : ''}`}>Tipos de Bonificaciones {isRequired('Type') ? <span className="text-danger">*</span> : ''}</label>
                            <EmployeeBonusTypeConstatsEditor idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
                        </div>
                        <div className="col-6">
                            <label className={`${isMissing('BonusValue') ? 'has-error' : ''}`}>Valor {isRequired('BonusValue') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" className="form-control" name="BonusValue" value={bean.BonusValue ?? ""} onChange={handleChange} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="VR Usuario" estado={bean.UserValue} eventChange={(e) => { setBean({ ...bean, "UserValue": e }) }} />
                        </div>
                        {/* <div className="col-6">
                            <label>Valor Tiempo Laborado para IBC</label>
                            <input type="number" className="form-control" name="ApportionmentTimeForPila" value={bean.ApportionmentTimeForPila} onChange={(e) => { setBean({ ...bean, "ApportionmentTimeForPila": e.target.value }) }} />
                        </div> */}
                        <div className="col-6">
                            <label className={`${isMissing('MinSalary') ? 'has-error' : ''}`}>Vr Mínimo {isRequired('MinSalary') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" className="form-control" name="MinSalary" value={bean.MinSalary ?? ""} onChange={handleChange} />
                        </div>
                        <div className="col-6">
                            <label className={`${isMissing('MaxSalary') ? 'has-error' : ''}`}>Vr Máximo {isRequired('MaxSalary') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" className="form-control" name="MaxSalary" value={bean.MaxSalary ?? ""} onChange={handleChange} />
                        </div>
                        <div className={`col-6 ${isMissing('MonthsJson') ? 'has-error' : ''}`}>
                            <label className={`${isMissing('MonthsJson') ? 'has-error' : ''}`}>Lista de Meses {isRequired('MonthsJson') ? <span className="text-danger">*</span> : ''}</label>
                            <MultiMonthEditor onChange={(e) => { setBean((prev: any) => ({ ...prev, "MonthsJson": Array.isArray(e) ? JSON.stringify(e) : e })) }} label=" " values={bean.MonthsJson} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${isMissing('EmploymentTypeJson') ? 'has-error' : ''}`}>Grupos Laborales {isRequired('EmploymentTypeJson') ? <span className="text-danger">*</span> : ''}</label>
                            <MultiEmploymentTypeEditor label=" " values={bean.EmploymentTypeJson} onChange={(e) => { setBean((prev: any) => ({ ...prev, "EmploymentTypeJson": Array.isArray(e) ? JSON.stringify(e) : e })) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Factor Salarial" estado={bean.WageFactor} eventChange={(e) => { setBean({ ...bean, "WageFactor": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Inlcuir en Nómina" estado={bean.FortnightInclude} eventChange={(e) => { setBean({ ...bean, "FortnightInclude": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Aplicar Retractivo" estado={bean.ApplyRetroactive} eventChange={(e) => { setBean({ ...bean, "ApplyRetroactive": e }) }} />
                        </div>
                        {/* <div className="col-6">
                            <SelectAccountantTree label="Cuenta por Pagar" jsonCode={bean.AccountantIDStr} onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-6">
                            <SelectAccountantTree label="Cuenta de Gasto" jsonCode={bean.ExpensiveAccountantIDStr} onChange={(e) => { setBean({ ...bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-6">
                            <SelectAccountantTree label="Cuenta de Costo" jsonCode={bean.CostAccountantIDStr} onChange={(e) => { setBean({ ...bean, "CostAccountantIDStr": e.JsonCode }) }} />
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Provisionar" estado={bean.DoProvision} eventChange={(e) => { setBean({ ...bean, "DoProvision": e }) }} />
                        </div>
                        <div className={`col-6 ${isMissing('IDEmployeeBenefit') ? 'has-error' : ''}`}>
                            <label className={`${isMissing('IDEmployeeBenefit') ? 'has-error' : ''}`}>Beneficio de Empleado {isRequired('IDEmployeeBenefit') ? <span className="text-danger">*</span> : ''}</label>
                            <EmployeeBenefitEditor
                                label=" "
                                idSelector={bean.IDEmployeeBenefit}
                                onChange={(e: any) => {
                                    setBean({
                                        ...bean,
                                        "IDEmployeeBenefit": e.IDEmployeeBenefit
                                    })
                                }}
                            />
                        </div>
                        {bean.DoProvision === true &&
                            <div className={`col-6 ${isMissing('ProvisionAccountantID') ? 'has-error' : ''}`}>
                                <SelectAccountantTree label={`Cuenta de Provision${isRequired('ProvisionAccountantID') ? ' *' : ''}`} idAccountant={bean.ProvisionAccountantID} onChange={(e) => { setBean({ ...bean, "ProvisionAccountantID": e.AccountantID }) }} />
                            </div>
                        }
                    </div>
                    <div className="row">

                        <div className="col-6">
                            <label className={`${isMissing('BonusFormula') ? 'has-error' : ''}`}>Clase Liquidador Prima {isRequired('BonusFormula') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="text" className="form-control" name="BonusFormula" value={bean.BonusFormula ?? ""} onChange={handleChange} />
                        </div>
                    </div>
                    {/* <div className="row">

                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Aplica Presupuesto" estado={bean.ApplyBudget} eventChange={(e) => { setBean({ ...bean, "ApplyBudget": e }) }} />
                        </div>
                        {bean.ApplyBudget === true &&
                            <div className="col-6">
                                <SelectBudgetID edit={false} tipoPresupuesto={null} jsonCode={bean.BudgetIDStr} onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} />
                            </div>
                        }
                    </div> */}
                    <div className="row">

                        <div className="col-6">
                            <TaxHoldeditor label="Factor de Retención" idSelector={bean.IDTaxHold} onChange={(e) => { setBean({ ...bean, "IDTaxHold": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Validar Tiempo Laborado" estado={bean.ApportionmentTime} eventChange={(e) => { setBean({ ...bean, "ApportionmentTime": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Incluir en Liquidacion Final" estado={bean.DoLiquidate} eventChange={(e) => { setBean({ ...bean, "DoLiquidate": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Retefuente" estado={bean.DoTaxHold} eventChange={(e) => { setBean({ ...bean, "DoTaxHold": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Descuentos" estado={bean.DoDiscounts} eventChange={(e) => { setBean({ ...bean, "DoDiscounts": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Provision Seguridad Social" estado={bean.DoVacProvision} eventChange={(e) => { setBean({ ...bean, "DoVacProvision": e }) }} />
                        </div>
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Aplicar a IBC sin Prorrateo de Tiempo" estado={bean.ApplyToIBCWithoutTimeRate} eventChange={(e) => { setBean({ ...bean, "ApplyToIBCWithoutTimeRate": e }) }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Pagar a Fondo" estado={bean.PaymentToWelfare} eventChange={(e) => { setBean({ ...bean, "PaymentToWelfare": e }) }} />
                        </div>
                        {bean.PaymentToWelfare === true &&
                            <>
                                <div className={`col-6 ${isMissing('WelfareType') ? 'has-error' : ''}`}>
                                    <WelfareEntityTypeEditor idSelector={bean.WelfareType} onChange={(e) => { setBean({ ...bean, "WelfareType": e }) }} label={`Tipo Fondo${isRequired('WelfareType') ? ' *' : ''}`} />
                                </div>
                                <div className="col-6 d-flex align-items-center">
                                    <BasicSwitch label="Usar Rubro Fondo" estado={bean.UseWelfareBudget} eventChange={(e) => { setBean({ ...bean, "UseWelfareBudget": e }) }} />
                                </div>
                            </>
                        }
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label className={`${isMissing('ProvisionCalculationMonths') ? 'has-error' : ''}`}>Meses de Provisión {isRequired('ProvisionCalculationMonths') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" className="form-control" name="ProvisionCalculationMonths" value={bean.ProvisionCalculationMonths ?? ""} onChange={handleChange} />
                        </div>
                        <div className="col-6">
                            <label className={`${isMissing('ProvisionCalculationPercent') ? 'has-error' : ''}`}>% Provisión {isRequired('ProvisionCalculationPercent') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" step="0.01" className="form-control" name="ProvisionCalculationPercent" value={bean.ProvisionCalculationPercent ?? ""} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 d-flex align-items-center">
                            <BasicSwitch label="Trae Beneficio a Valor Presente" estado={bean.BringToPresentValue} eventChange={(e) => { setBean({ ...bean, "BringToPresentValue": e }) }} />
                        </div>
                        {bean.BringToPresentValue === true &&
                            <>
                                <div className="col-6">
                                    <label className={`${isMissing('DiscountRate') ? 'has-error' : ''}`}>Tasa de Descuento {isRequired('DiscountRate') ? <span className="text-danger">*</span> : ''}</label>
                                    <input type="number" step="0.01" className="form-control" name="DiscountRate" value={bean.DiscountRate ?? ""} onChange={handleChange} />
                                </div>
                                <div className="col-6">
                                    <label className={`${isMissing('TurnoverRate') ? 'has-error' : ''}`}>Tasa de Rotación {isRequired('TurnoverRate') ? <span className="text-danger">*</span> : ''}</label>
                                    <input type="number" step="0.01" className="form-control" name="TurnoverRate" value={bean.TurnoverRate ?? ""} onChange={handleChange} />
                                </div>
                            </>
                        }
                    </div>
                </Modal>
            }

            {modalEBV.view &&
                <Modal modal={modalEBV} updateModal={setModalEBV} >
                    <EmploymentBonusValue idEmploymentBonus={bean.IDEmploymentBonus} />
                </Modal>
            }

            {modalAppointment.view &&
                <Modal modal={modalAppointment} updateModal={setModalAppointment} >
                    <AppointMentByEmploymentBonu idEmploymentBonus={bean.IDEmploymentBonus} />
                </Modal>
            }

            {modalC.view &&
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>
            }

            <ModalConfirm modal={modalAllAppointment} updateModal={setModalAllAppointment} eventModal={activateBonus}>
                <p>¿Esta seguro que desea activar <strong>{bean.Name}</strong> en todos los niveles salariales?</p>
            </ModalConfirm>

            <Modal modal={modalAddUser} updateModal={setModalAddUser} eventModal={addEmployeeToBonus} >
                <div className="row">
                    <div className="col-md-6">
                        <AccountEditor label="Empleado" idAccount={response.IDAccount} onChange={(e) => { setResponse({ ...response, "IDAccount": e.IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Valor del Beneficio" _value={response.BonusValue} onChange={(e) => { setResponse({ ...response, "BonusValue": e }) }} />
                    </div>
                    <div className="col-md-6 d-flex-wrap align-content-center">
                        <BasicSwitch label="Beneficio Temporal" estado={response.IsTemporary} eventChange={(e) => { setResponse({ ...response, "IsTemporary": e }) }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <InputDate notDate label="Fecha Inicio" name="From" value={response.From} setDate={(e) => { setResponse({ ...response, "From": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate notDate label="Fecha Fin" name="Upto" value={response.Upto} setDate={(e) => { setResponse({ ...response, "Upto": e }) }} />
                    </div>
                </div>
            </Modal>
        </>
    )
}
